import type { ShapeManagerRef } from '@/lib/shapes/types/shape-manager-ref'

import type { ArrangeOp } from '../types/layout-operations'
import type { LayoutPanelProps } from '../types/layout-panel-props'

type ArrangeContext = {
  mgr: ShapeManagerRef | null | undefined
  /** Ids of the selected objects (from the activeObjects context). */
  selectedIds: string[]
  onLayerReorder: LayoutPanelProps['onLayerReorder']
  onUnifiedLayerArrange: LayoutPanelProps['onUnifiedLayerArrange']
}

/**
 * Runs one Arrange action: reorders the manager's shapes (reported for undo via
 * `onLayerReorder`), then updates the unified z-order. Each `ArrangeOp` is also the name of the
 * `ShapeManagerRef` method that performs it.
 */
export function handleArrange(
  op: ArrangeOp,
  { mgr, selectedIds, onLayerReorder, onUnifiedLayerArrange }: ArrangeContext
): void {
  if (selectedIds.length === 0) {
    return
  }

  const result = mgr?.[op]()

  if (result && onLayerReorder) {
    onLayerReorder(result.beforeOrder, result.afterOrder)
  }

  onUnifiedLayerArrange?.(selectedIds, op)
}
